import { PRODUCT_FAMILY_NAME } from 'common/constants'
import { useBranding } from '../../queries/branding'

export const PageTitle = ({ title }: { title: string }) => {
  const branding = useBranding().data
  const productName = branding ? ` - ${branding.customTabTitle || PRODUCT_FAMILY_NAME}` : ''
  return <title>{`${title}${productName}`}</title>
}
